import type { QuizResults } from '../state/flow';

// The quiz half persists across sessions (unlike the in-memory ID-card flow):
// completed report cards must survive a refresh / return visit. We store only
// small results DATA (scores + the name used), never rendered images — the
// cards regenerate from this in HTML/CSS.

const KEY = 'oc-quiz-v1';

export interface QuizStore {
  name: { firstName: string; lastName: string };
  results: QuizResults;
}

const EMPTY: QuizStore = { name: { firstName: '', lastName: '' }, results: {} };

/** Read the persisted quiz state. Fails soft (private mode, disabled storage,
 * corrupt JSON) by returning an empty store. */
export function loadQuiz(): QuizStore {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return EMPTY;
    const parsed = JSON.parse(raw) as Partial<QuizStore>;
    return {
      name: {
        firstName: parsed.name?.firstName ?? '',
        lastName: parsed.name?.lastName ?? '',
      },
      results: parsed.results ?? {},
    };
  } catch {
    return EMPTY;
  }
}

/** Write the quiz state. Fails soft — a storage error never breaks the flow. */
export function saveQuiz(store: QuizStore): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    // Private mode / quota / disabled storage — quiz still works in-memory.
  }
}
